import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <span className="footer-logo">SUPLYMAR</span>
      <p className="footer-tagline">Productos ortopédicos para tu bienestar diario</p>
      <p className="footer-copy">&copy; 2026 Suplymar. Todos los derechos reservados.</p>
    </footer>
  );
}

export default Footer;
